import { render, staticRenderFns } from "./Amex.vue?vue&type=template&id=dba3db2a&scoped=true&"
import script from "./Amex.vue?vue&type=script&lang=js&"
export * from "./Amex.vue?vue&type=script&lang=js&"
import style0 from "./Amex.vue?vue&type=style&index=0&id=dba3db2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dba3db2a",
  null
  
)

export default component.exports